require('./farm-branding/farm-branding.scss');
var BaseViews = require('./base');
var FarmBrandingF = BaseViews.ItemView.extend({
  initialize: function (options) {
      var self = this;
      this.options = _.defaults(
          options || {},
          {
              clickUrl: null,
              size: 'full', // full, half
              color: 'white' // white, black
          }
      );
  },
  template: function () {
    return '<div class="fmy-branding-f"></div>'
  },
  className: 'fmy-branding-f'
});


var FarmBrandingFull = BaseViews.ItemView.extend({
  initialize: function (options) {
      var self = this;
      this.options = _.defaults(
          options || {},
          {
              size: 'full', // full, half
              color: 'white' // white, black
          }
      );
  },
  template: function () {
    return '<div class="fmy-branding-logo-full"></div>'
  },
  className: 'fmy-branding-logo-full-wrapper'
});

var FarmBranding = BaseViews.LayoutView.extend({
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                style: 'f', // f, full
                color: 'white'
            }
        );
    },
    className: 'fmcy-branding',
    template: require('./farm-branding/farm-branding.html'),
    regions: {
      logoRegion: '.farm-branding-region'
    },
    events: {
        'click': 'onClick'
    },
    onClick: function() {
        this.trigger('clicked');
    },
    _renderFLogo: function () {
      this._logo = new FarmBrandingF();
      this.logoRegion.show(this._logo);
    },
    _renderFullLogo: function () {
      this._logo = new FarmBrandingFull();
      this.logoRegion.show(this._logo);
    },
    onRender: function () {
      var self = this;
      switch (this.options.style) {
        case 'f':
          this._renderFLogo();
        break;
        default:
          this._renderFullLogo();
        break;
      }
    }
});
module.exports = FarmBranding;



/** WEBPACK FOOTER **
 ** ./assets/js/common/farm-branding.js
 **/